// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3NIuP","large":"styles_large__1ycRA"};